interface StarRatingProps {
  rating: number;
  className?: string;
  showValue?: boolean;
  count?: number | null;
}

export default function StarRating({ rating, className = "text-sm", showValue = false, count }: StarRatingProps) {
  const rounded = Math.round(Number(rating) || 0);
  return (
    <span className={`inline-flex items-center gap-1 ${className}`}>
      <span className="inline-flex items-center gap-0.5 text-primary-500">
        {[1, 2, 3, 4, 5].map((star) => (
          <i key={star} className={star <= rounded ? "ri-star-fill" : "ri-star-line"}></i>
        ))}
      </span>
      {showValue && <span className="text-foreground-800 font-medium">{Number(rating).toFixed(2)}</span>}
      {typeof count === "number" && <span className="text-foreground-400">({count})</span>}
    </span>
  );
}